<page-toolbar [pageActions]="pageActions" title="{{'pages.resources' | translate}}: {{currentPage?.title}}"></page-toolbar>

<div class="resource-container">
  <div class="media-container">
    <div class="menu-buttons">
      <div class="menu-button" *ngFor="let entrance of dynamicContentEntrances; let i = index"
           (click)="openTab(entrance._id)" [ngClass]="{'active': tabIndex === i}" [id]="entrance._id">
        {{entrance.title}}
        <mat-icon *ngIf="entrance.isSecured">group</mat-icon>
      </div>
    </div>
    <div class="tab-content" *ngIf="currentPage">
      <div class="pages">
        <div *ngFor="let page of pages; let i = index" (click)="tabChange(i)" class="page"
             [ngClass]="{'active': selectedTab === i}">{{page.title}}</div>
      </div>
      <assets (select)="onSelect($event)" [type]="currentPage.type" [content]="currentPage.content" [showAll]="currentPage.showAll"
              [title]="currentPage.title" [packageId]="packageIds" [entrances]="dynamicContentEntrances" [class.loading]="isLoading"></assets>
    </div>
  </div>
</div>

<div *ngIf="isLoading" class="spinner-container">
  <mat-spinner></mat-spinner>
</div>

